import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import ElegirVentanas from './ElegirVentanas';
import { normalizarVentanas } from '../../utils/franjas';

// Cambiar cuándo pueden recibirnos (16-oct-2026): la empresa, mientras el técnico todavía
// no eligió el día. Al técnico y al admin les llega el aviso.
export default function CambiarHorarioSheet({ pedido, onCerrar, onListo }) {
    const [ventanas, setVentanas] = useState(Array.isArray(pedido.ventanas) ? normalizarVentanas(pedido.ventanas) : []);
    const [guardando, setGuardando] = useState(false);

    const guardar = async () => {
        if (!ventanas.length) { toast.error('Marcá cuándo pueden recibirnos'); return; }
        setGuardando(true);
        try {
            const r = await api.patch(`/empresa/pedidos/${pedido.id}/horario`, { ventanas });
            toast.success('Horario cambiado · le avisamos al técnico');
            onListo(r.data);
        } catch (e) {
            toast.error(e?.response?.data?.mensaje || 'No se pudo cambiar el horario');
        } finally { setGuardando(false); }
    };

    return (
        <ModalShell titulo="¿Cuándo pueden recibirnos?" subtitulo={`Pedido #${pedido.id}`} onCerrar={onCerrar}
            pie={<button type="button" disabled={guardando || !ventanas.length} onClick={guardar}
                className="w-full h-12 rounded-xl bg-[#C9341F] text-white font-black text-body active:scale-95 disabled:opacity-40">
                {guardando ? 'Guardando…' : 'Guardar horario'}</button>}>
            <ElegirVentanas value={ventanas} onChange={setVentanas} />
        </ModalShell>
    );
}
